<template>
  <h1 class="title">
    <div v-show="back" @click="goBack"><i class="el-icon-arrow-left"></i>返回</div>
    <slot></slot>
  </h1>
</template>
<script>
export default {
  props: {
    back: { type: Boolean, default: false }
  },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
</script>
